// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"link-list_sectionTitle__F5_wX","list":"link-list_list__7oULL","listItem":"link-list_listItem__XG4vR"};